export const DEFAULT_PRIMARY_COLOR = '#475254'
export const DEFAULT_SECONDARY_COLOR = '#A3AEAC'

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/
const API_ORIGIN = (process.env.REACT_APP_API_BASE || 'http://localhost:8000')
  .replace(/\/api\/?$/, '')
  .replace(/\/$/, '')

function normalizeColor (value, fallback) {
  return HEX_COLOR.test(value || '') ? value : fallback
}

function hexToRgb (hex) {
  const value = hex.replace('#', '')
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16)
  }
}

function tintColor (hex, amount) {
  const { r, g, b } = hexToRgb(hex)
  const tint = channel => Math.round(channel + (255 - channel) * amount)
  return `rgb(${tint(r)}, ${tint(g)}, ${tint(b)})`
}

function colorLuminance (hex) {
  const { r, g, b } = hexToRgb(hex)
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

export function resolveBusinessUnitLogoUrl (logoUrl) {
  if (!logoUrl) return ''
  if (/^(https?:)?\/\//.test(logoUrl) || /^(data|blob):/.test(logoUrl)) return logoUrl
  if (logoUrl.startsWith('/')) return `${API_ORIGIN}${logoUrl}`
  return `${API_ORIGIN}/${logoUrl}`
}

export function getBusinessUnitTheme (source = {}) {
  const primaryColor = normalizeColor(source.session_business_unit_primary_color || source.primary_color, DEFAULT_PRIMARY_COLOR)
  const secondaryColor = normalizeColor(source.session_business_unit_secondary_color || source.secondary_color, DEFAULT_SECONDARY_COLOR)
  // Ink = the darker of the template's two palette colors. Per the Figma Form
  // Card specs (Milwaukee 1185:28452, TTI Asia 1190:30128) it colors the form's
  // section header bars: Milwaukee → its black secondary #111111, TTI → its
  // grey primary #475254.
  const inkColor = colorLuminance(primaryColor) <= colorLuminance(secondaryColor) ? primaryColor : secondaryColor
  return {
    logoUrl: resolveBusinessUnitLogoUrl(source.session_business_unit_logo_url || source.logo_url || ''),
    primaryColor,
    secondaryColor,
    inkColor,
    primaryBackground: tintColor(primaryColor, 0.88),
    secondaryBackground: tintColor(secondaryColor, 0.88),
    primaryBorder: tintColor(primaryColor, 0.55),
    secondaryBorder: tintColor(secondaryColor, 0.55)
  }
}

export function businessUnitThemeVars (theme) {
  return {
    '--bu-primary': theme.primaryColor,
    '--bu-secondary': theme.secondaryColor,
    '--bu-ink': theme.inkColor,
    '--bu-primary-bg': theme.primaryBackground,
    '--bu-secondary-bg': theme.secondaryBackground,
    '--bu-primary-border': theme.primaryBorder,
    '--bu-secondary-border': theme.secondaryBorder
  }
}
